module.exports = __webpack_public_path__ + "static/media/rate-up.7a651434.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rate-up.svg
// module id = 894
// module chunks = 7